/**
 * Condition model
 */

import { Command, SetupCommandData } from './Command';
import { Check, SetupCheckData } from './Check';

export class Condition {
    conditionname: string = "";
    PassCommands: (Command | Condition)[] = [];
    FailCommands: (Command | Condition)[] = [];
    Checks: Check[] = [];
}

export function SetupConditionData(GameData: any[]): Condition {
    const CurCondition = new Condition();
    CurCondition.conditionname = GameData[1];
    for (let i = 0; i < GameData[2].length; i++) {
        CurCondition.Checks.push(SetupCheckData(GameData[2][i]));
    }
    for (let j = 0; j < GameData[3].length; j++) {
        if (GameData[3][j][0] === "CMD") {
            CurCondition.PassCommands.push(SetupCommandData(GameData[3][j]));
        } else {
            CurCondition.PassCommands.push(SetupConditionData(GameData[3][j]));
        }
    }
    for (let k = 0; k < GameData[4].length; k++) {
        if (GameData[4][k][0] === "CMD") {
            CurCondition.FailCommands.push(SetupCommandData(GameData[4][k]));
        } else {
            CurCondition.FailCommands.push(SetupConditionData(GameData[4][k]));
        }
    }
    return CurCondition;
}
